module.exports = [
	{
		"start": "Fri 07/29/16 at 2:00 PM",
		"end": "Fri 07/29/16 at 3:00 PM",
		"actor": "Mark Kingston"
	},
	{
		"start": "Mon 01/08/16 at 3:00 PM",
		"end": "Mon 01/08/16 at 4:00 PM",
		"actor": "Jamie Fletcher"
	},
	{
		"start": "Fri 08/26/16 at 5:00 PM",
		"end": "Fri 08/26/16 at 6:00 PM",
		"actor": "Dr. John Smith"
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./~/json-loader!./src/www/resources/appointments-upcoming.json
 ** module id = 886
 ** module chunks = 0
 **/